import {Component} from 'react';
import h from 'react-hyperscript';
import './ProductUsage.scss';
import BasicCard from 'Components/Cards/BasicCard';
import {h4, eyebrow} from 'Components/Typography/Typography';
import DonutChart from 'Components/DataViz/DonutChart/DonutChart';
import {
  getAvg,
  setZeroIfInvalidNumber,
  largestInColumn,
  getRemainingPercent,
  isArrayEmpty,
  getPercentageDifference,
} from 'Src/utils/utils';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import ReportError from 'Components/ErrorMessage/ReportError';

class ProductUsage extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      gsuiteUsage: 0,
      chromebookUsage: 0,
      isLoaded: false,
      totalNumUsers: null,
      hasError: false,
    };
  }

  componentWillMount() {
    this._isMounted = true;
    this.setData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData() {
    if (this.dataAvailable) {
      this.setTotalNumUsers();
    } else {
      this.setHasError(true);
    }
  }

  get dataAvailable() {
    return (
      this.props.hasProductMetricsHistory &&
      !isArrayEmpty(this.props.productMetrics) &&
      !isArrayEmpty(this.props.graphs) &&
      !isArrayEmpty(this.props.gsuiteMetrics)
    );
  }

  setHasError(value) {
    this.setState({
      isLoaded: true,
      hasError: value,
    });
  }

  getAvgs() {
    if (this.state.totalNumUsers) {
      const weeklyGSuiteAvgs = this.getWeeklyGsuiteUsage(
          this.props.gsuiteMetrics
      );
      const weeklyGSuiteAvgsPrev = this.getWeeklyGsuiteUsage(
          this.props.gsuiteMetricsPrev
      );

      this.updateState('gsuiteUsage', setZeroIfInvalidNumber(weeklyGSuiteAvgs));

      if (weeklyGSuiteAvgsPrev) {
        this.updateState(
            'gsuiteUsagePrev',
            setZeroIfInvalidNumber(weeklyGSuiteAvgsPrev)
        );
      }

      const chromebookUsage = this.getChromebookUsage(
          this.props.productMetrics
      );
      const chromebookUsagePrev = this.getChromebookUsage(
          this.props.productMetricsPrev,
          true
      );

      this.updateState(
          'chromebookUsage',
          setZeroIfInvalidNumber(chromebookUsage)
      );

      if (chromebookUsagePrev) {
        this.updateState(
            'chromebookUsagePrev',
            setZeroIfInvalidNumber(chromebookUsagePrev)
        );
      }
    }
  }

  getChromebookUsage(productMetrics, isPrev) {
    if (!productMetrics) return;

    const weeklyActiveDevices = productMetrics.map((week) => {
      const prodMetrics = week;
      const chromebookWeeklyData = prodMetrics['cros'];
      return chromebookWeeklyData;
    });

    const avgWeeklyDevices = getAvg(weeklyActiveDevices);
    const numUsers = isPrev ?
      this.state.totalNumUsersPrev :
      this.state.totalNumUsers;
    const percentage = avgWeeklyDevices / numUsers;

    return setZeroIfInvalidNumber(percentage);
  }

  getWeeklyGsuiteUsage(gsuiteMetrics) {
    if (!gsuiteMetrics) return;

    const gsuiteWeeklyData = gsuiteMetrics.map((product) => {
      const metrics = product.metrics.map((week) => {
        return week.metric;
      });
      return metrics;
    });
    const res = largestInColumn(gsuiteWeeklyData);
    let avg = getAvg(res);
    avg = avg <= 1.0 ? avg : 1.0;

    return avg;
  }

  getBenchmarking(id) {
    return getPercentageDifference(this.state[id], this.state[id + 'Prev']);
  }

  setTotalNumUsers() {
    const {totalNumUsers, totalNumUsersPrev} = this.props;

    this.setState(
        {
          totalNumUsers,
          totalNumUsersPrev,
        },
        () => {
          this.getAvgs();

          this.setState({
            isLoaded: true,
          });
        }
    );
  }

  updateState(key, value) {
    if (this._isMounted) {
      this.setState({
        [key]: value,
      });
    }
  }

  createGraphHeader(graph) {
    if (graph.tooltip) {
      return h(
          TooltipGroup,
          {
            title: graph.tooltip,
            className: 'flex--center',
          },
          h(
              eyebrow,
              {
                key: `product-usage-eyebrow`,
                className: 'text--center product-usage__eyebrow',
              },
              graph.title
          )
      );
    } else {
      return h(
          eyebrow,
          {
            key: `product-usage-eyebrow`,
            className: 'text--center product-usage__eyebrow',
          },
          graph.title
      );
    }
  }

  render() {
    if (this.state.isLoaded) {
      return h(
          BasicCard,
          {
            id: this.props.id,
            className: this.props.className,
          },
          [
            h(
                TooltipGroup,
                {
                  title: this.props.tooltip,
                },
                h(
                    h4,
                    {
                      key: 'title__key',
                      className: 'card__title',
                    },
                    this.props.title
                )
            ),
          this.state.hasError ?
            h(
                ReportError,
                {
                  message: this.props.noDataError,
                },
                null
            ) :
            h('div', null, [
              h(
                  'div',
                  {
                    key: 'graphs__key',
                    className: 'flex--space-around--all',
                  },
                  [
                    this.props.graphs.map((graph, i) => {
                      const data = getRemainingPercent(this.state[graph.id]);
                      return h(
                          'div',
                          {
                            key: `${graph.id}-graph__key`,
                            className: `product-usage__graph-container
                            flex--center flex--wrap-all`,
                          },
                          [
                            this.createGraphHeader(graph),
                            h(
                                DonutChart,
                                {
                                  key: `${i}__key`,
                                  id: `survey__graph__${graph.id}`,
                                  data,
                                  dataChange: this.getBenchmarking(graph.id),
                                  title: graph.title,
                                  color: graph.color,
                                  size: [120, 120],
                                },
                                null
                            ),
                          ]
                      );
                    }),
                  ]
              ),
            ]),
          ]
      );
    } else {
      return h(LoadingIndicator, null, null);
    }
  }
}

export default ProductUsage;
